import {DTNativeCreativeNode, DTNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType, ServerNode} from 'common/src/modules/nodes/nodes.types';
import {serializeCreativeNode} from 'common/src/modules/campaignVersions/utils/serializeConceptCreativeNode';

export function serializeNativeCreativeNode(node: DTNode, newNode: ServerNode) {
  const creativeNode = node as DTNativeCreativeNode;

  return {
    ...serializeCreativeNode(node, newNode),
    type: NodeType.NATIVE_CREATIVE,
    nativeAdTitle: creativeNode.nativeAdTitle,
    nativeAdDescription: creativeNode.nativeAdDescription,
    nativeAdSponsor: creativeNode.nativeAdSponsor,
    nativeAdCTA: creativeNode.nativeAdCTA,
    nativeAdLogo: creativeNode.nativeAdLogo,
    nativeAdLogoSize: creativeNode.nativeAdLogoSize,
  };
}
